(() => {
  // --- KONFIGURATION ---
  const SHIPPING_RULES = {
    "EUR": { limit: 80,  format: "{val}€" },     // DE, AT, FR, ES etc.
    "DKK": { limit: 600, format: "{val} kr" },   // Dänemark
    "NOK": { limit: 940, format: "{val} kr" },   // Norwegen
    "SEK": { limit: 860, format: "{val} kr" },   // Schweden
    "USD": { limit: 80,  format: "${val}" },     // USA ($ vor dem Betrag)
    "GBP": { limit: 80,  format: "£{val}" }      // UK / Pfund (£ vor dem Betrag)
  };

  // Text im Shop, nach dem gesucht werden soll:
  // Matcht "Up to 30% off shipping" mit variablen Leerzeichen und optionalem Satzzeichen am Ende
  const TARGET_REGEX = /Up\s*to\s*30%\s*off\s*shipping(\s*[.!?])?/gi;

  function getActiveCurrency() {
    const s = window.Shopify || {};
    // Versucht verschiedene Pfade, da Shopify Themes variieren können
    return String(s.currency?.active || s.currency?.currency || s.currency?.shop_currency || "").toUpperCase();
  }

  function isGerman() {
    const lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return lang.indexOf("de") === 0;
  }

  // Prüft, ob wir für die aktuelle Währung überhaupt eine Regel haben
  function shouldReplace() {
    const iso = getActiveCurrency();
    return Object.prototype.hasOwnProperty.call(SHIPPING_RULES, iso);
  }

  function getReplacementString() {
    const iso = getActiveCurrency();
    const rule = SHIPPING_RULES[iso];
    
    // Safety check
    if (!rule) return null;

    const money = rule.format.replace("{val}", rule.limit);

    // Unterscheidung Deutsch / Englisch (bzw. Rest der Welt)
    if (isGerman()) {
      return `Kostenloser Versand ab ${money}`;
    } else {
      return `Free shipping from ${money}`;
    }
  }

  function replaceInTextNode(node) {
    const txt = node.nodeValue;
    if (!txt) return false;
    // Prüfen ob der Ziel-Text überhaupt drin vorkommt
    if (!TARGET_REGEX.test(txt)) return false;

    // Regex state resetten
    TARGET_REGEX.lastIndex = 0;

    const rep = getReplacementString();
    if (!rep) return false;

    node.nodeValue = txt.replace(TARGET_REGEX, (match, punct) => {
      // Satzzeichen (Punkt, Ausrufezeichen) beibehalten, falls im Original vorhanden
      return punct ? `${rep}${punct}` : rep;
    });

    return true;
  }

  function replaceEverywhere(root) {
    // Wenn Währung NICHT in unserer Liste ist -> Abbruch.
    if (!shouldReplace()) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        if (!n.nodeValue) return NodeFilter.FILTER_REJECT;
        // Schneller Vorab-Check bevor Regex läuft
        if (!/Up/i.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    let changed = false;
    for (const n of nodes) {
      // Script und Style Tags ignorieren
      const p = n.parentElement;
      if (p && (p.tagName === "SCRIPT" || p.tagName === "STYLE" || p.tagName === "NOSCRIPT")) continue;
      changed = replaceInTextNode(n) || changed;
    }
    return changed;
  }

  function run() {
    replaceEverywhere(document.body);
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Observer für dynamische Inhalte (Warenkorb-Drawer, Popups, etc.)
  const obs = new MutationObserver(() => {
    if (!shouldReplace()) return;
    run();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Falls Währung oder Tab gewechselt wird -> neu prüfen
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") run();
  });
  window.addEventListener("focus", run);
})();